import { format } from 'date-fns';

export default (timestamp, formatString) => {
  if (!timestamp || !formatString) return timestamp;

  const timestampInMilliseconds = timestamp * 1000;
  return format(timestampInMilliseconds, formatString);
};
